import { Component, ViewChild, OnDestroy } from '@angular/core';
import { SideNavServiceService } from './core/services/side-nav/side-nav-service.service';
import { MatSidenav } from '@angular/material/sidenav';
import { Router, NavigationEnd, ActivationEnd, NavigationStart, ActivatedRoute } from '@angular/router';
import { NavBarService } from './core/services/nav-bar/nav-bar.service';
import { AuthorizationService } from './core/services/authorization/authorization.service';
import { ConfigService } from './core/services/config.service';
import { RedirectService } from './core/services/redirect/redirect.service';
import { Subscription } from 'rxjs';
import { LoaderService } from './core/services/loader/loader.service';
import { Title } from '@angular/platform-browser';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnDestroy {

  showHeaderandFooter: boolean = false;
  spinnerSubscribe: Subscription;
  modules: any;
  loading = false;
  constructor(
    private router: Router,
    private sideNavService: SideNavServiceService,
    private authorizationService: AuthorizationService,
    private navBarService: NavBarService,
    private configService: ConfigService,
    private redirectService: RedirectService,
    private loaderService: LoaderService,
    private activatedRoute: ActivatedRoute,
    private titleService: Title
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationStart) {
        if (event['url'].endsWith('master-list') || event['url'].includes('preview-waiver-form') || event['url'].includes('students/view-student-waiver/print') || event['url'].includes('view-initial-waiver') || event['url'].includes('manage-referrals/view-referral/print') || event['url'].includes('logout')) {
          this.showHeaderandFooter = false;
        } else {
          this.showHeaderandFooter = true;
        }
      }
    });
    this.modules = this.configService.modules;

    this.spinnerSubscribe = this.loaderService.hideSpinner.subscribe(value => {
      this.loading = value;
    });
  }

  @ViewChild('sideNav', { static: true }) public sideNav: MatSidenav;

  ngOnInit() {
    this.sideNavService.setSidenav(this.sideNav);
    this.router.events.subscribe((event) => {

      if (event instanceof ActivationEnd) {
        if (event.snapshot.data.pageTitle) {
          this.navBarService.setTitleBarValue(event.snapshot.data.pageTitle);
        }
      }

      if (event instanceof NavigationEnd) {
        window.scrollTo(0, 0);
      }
    });
    this.modules.forEach((module) => {
      module.isAccessible = (module.transform && !module.isDisabled && this.canAccess(module));
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => {
      const rt = this.getChild(this.activatedRoute);
      rt.data.subscribe(data => {
        this.titleService.setTitle(data.title ? data.title : "Partner Center")
      });
    });
  }

  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      return this.getChild(activatedRoute.firstChild);
    } else {
      return activatedRoute;
    }
  }

  canAccess(module) {
    let flag = this.authorizationService.canAccess(module);
    module.isDisabled = !flag;
    if (this.isWaiver(module.blockName)) {
      flag = true;
    }
    return flag;
  }

  getFullUrl(module) {
    if (module.transform) {
      return this.redirectService.getFullUrl(module.url, true);
    } else {
      return module.url;
    }
  }

  isWaiver(moduleName: string) {
    if ((moduleName === 'Waiver Management') || (moduleName === 'WaiverManagement')) {
      return true;
    } else {
      return false;
    }
  }
  ngOnDestroy() {
    this.spinnerSubscribe.unsubscribe();
  }
}
